import GetImage from '../../components/getimage/Getimage';
import { StatusComponent } from './StatusComponent';
import { getMeetingDay } from './utility/getMeetingDay';
import getMeetingTime from './utility/getMeetingTime';
import meetingmom from "../../assets/document.png"

import './meetinglist.css'
import Hexapi from '../../utility/HexAPI/aborthexapi/hex';
let activeRowId=null
const Meetinglist = ({list,GetMeetingDetails,meetingid}) => {
  console.log(list,"listt")
  const getDateOnly=(date)=>{
    console.log(date,"dateeeeeee")
    return date?.split(" ")[0]
  }
let lastDate = "";

const circle1 = {
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  backgroundColor: "#9ca3af",
  border: "2px solid white",
  zIndex: 1
};
const getFontSize = (count) => {
  if (count < 10) return "12px";
  if (count < 100) return "10px";
  return "8px";
};
const circle2 = {
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  backgroundColor: "#9ca3af",
  border: "2px solid white",
  marginLeft: "-11px",
  zIndex: 2
};

const countCircle = {
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  backgroundColor: "#9ca3af",
  border: "2px solid white",
  marginLeft: "-11px",
  zIndex: 3,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "10px",
  fontWeight: "600",
  color: "white"
};
  return (
    <div style={{position:"relative"}}>
        {list && (
          <div className='meetingscroll' >
            {
              list?.length > 0 ? <div>
                {
                  list?.map((item,index)=>{
                    const empIds = item?.empids?.split(",") || [];
                     const currentDate = getDateOnly(item?.scheduledtime?.date);
                     const showHeader = (item.stage == 0 && currentDate !== lastDate)
                       if (item.stage == 0) {
                  lastDate = currentDate;
                }
return(
  <div onClick={()=>{
      if (activeRowId && activeRowId != item?.meetingid) {
    Hexapi.cancelPreviousRow(activeRowId);  
  }

  
  GetMeetingDetails(item?.meetingid)
  activeRowId = item?.meetingid;
  
                  }} key={item?.meetingid} className={`meetingtilenew meeting-item ${meetingid == item?.meetingid ? 'activemeeting' : ''}`}  
          style={{ animationDelay: `${index * 0.1}s` }}>

             {showHeader && (
        <div className="dateHeader">
         <div style={{display:"flex" , justifyContent:"space-between" , alignItems:"center", marginBottom:"10px"}}>
      <p style={{marginBottom:"0px"}} className='scheduledmeeting'><StatusComponent data={item}/></p>
      <p style={{marginBottom:"0px"}} className='todaymeeting'>{getMeetingDay(item?.scheduledtime?.date)}</p>
      </div>
        </div>
      )}
      {item.stage != 0 && (
        <div className="dateHeader">
         <div style={{display:"flex" , justifyContent:"space-between" , alignItems:"center", marginBottom:"10px"}}>
      <p style={{marginBottom:"0px"}} className='scheduledmeeting'><StatusComponent data={item}/></p>
      <p style={{marginBottom:"0px"}} className='todaymeeting'>{getMeetingDay(item?.scheduledtime?.date)}</p>
      </div>
        </div>
      )}
    
      <div className={`meetingtile ${meetingid == item?.meetingid ? 'activemeeting' : ''}`} >
         <div className='leftsec'>
         <div className='imagesection'>
        <div>
          <GetImage key={item?.hostempid} imgID={item?.hostempid} width='45px' height='45px'/>
          </div>
          <div>
            <p style={{marginBottom:"0px"}} className='meetingddescription'>{item?.name}</p>
            <div className='timemeeting'>
            <span style={{color:"#374151"}}>{getMeetingTime(item?.scheduledtime?.date)}</span> - <span>{getMeetingTime(item?.endtime?.date)}</span>
              </div>
          </div>
      </div>

      <div className='attendeesmom'>
        {
          item.hasmom != 0 ? <img src={meetingmom} className='img-fluid meetinggroupimg'/> : ""
        }

    
        <div>
          </div>
 
{
 ( item.empids && item?.attendees > 0) && (
    <div style={{ display: "flex", alignItems: "center" }}>
      
     
    {empIds[0] && (
    <div style={circle1}>
      <GetImage imgID={empIds[0]} width="100%" height="100%" />
    </div>
  )}

      {item?.attendees >= 2 && (
         <div style={circle2}>
      <GetImage imgID={empIds[1]} width="100%" height="100%" />
    </div>
      )}
{item?.attendees > 2 && (
  <div
    style={{
      ...countCircle,
      fontSize: getFontSize(item.attendees - 2),
    }}
  >
    +{item.attendees - 2}
  </div>
)}
    </div>
  )
}

{
  (item.attendees && !item.empids) && <div
    style={{
      ...countCircle,
      fontSize: getFontSize(item.attendees - 2),
    }}
  >
    {item.attendees}
  </div>
}
        
        
        </div>
        </div>
        </div>
     
    </div>
)
                  })
                }
                </div>  : ""
            }
          </div>
        )}

    </div>
  );
};
export default Meetinglist;